export default __webpack_public_path__ + "static/media/volume-icon.a06cd8f2.svg";